import { defineStyleConfig } from '@chakra-ui/react';

const FormLabel = defineStyleConfig({
  baseStyle: {
    fontSize: 'sm',
  },
});
export default FormLabel;
